<template>
  <v-app class="py-0 px-0 mod--background_transparent">
    <!-- NAVIGATION MENU -->
    <app-bar :numberSelected="numberSelected"></app-bar>
    <!-- ACTUAL PAGE -->
    <!-- <v-card elevation="0" class="justify-center py-0 px-0">
      <h2>Home in manutenzione!</h2>
      <p>
        <strong>B2B funzionante</strong>
        accedi da
        <a href="/login" class="text-decoration-none"><strong>QUI</strong></a>
      </p>
    </v-card> -->
    <!-- APP FOOTER -->
    <app-footer></app-footer>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
const AppBar = () => import("@/components/core/AppBar.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
  },
})
export default class Home extends Vue {
  // VARS --- COMPONENTS
  private numberSelected = 0;

  created(): void {
    window.location.href = "http://bracchiruote.it";
  }
}
</script>

<style lang="sass" scoped>
.display_row > *
   align-self: stretch
   > *
      min-height: 100%

.container
   padding: 0!important

.container.fill-height > *
   min-width: 100%

.v-application--wrap
   min-height: auto

.theme--light.v-icon
   color: var(--v-light-base) !important
</style>
